/* eslint-disable no-restricted-syntax */
import { fireAuth, fireStore, serverNowDateValue } from '../utils/firebase';
import { transaction, transactionItems } from '../utils/collections';
import {
  TrackingCodes,
  TransactionEventTypes,
  TransactionStatusTypes
} from '../../utils/constants';

export const createTransaction = (items) => {
  const clientID = fireAuth.currentUser.uid;

  const transactionData = {
    clientID,
    // address,
    createdAt: serverNowDateValue()
  };

  const batch = fireStore.batch();
  const transRef = transaction.doc();
  batch.set(transRef, transactionData);

  for (const item of items) {
    const { productID, productCost, sellerID, deliveryCost, quantity } = item;
    const itemRef = transactionItems.doc();
    batch.set(itemRef, {
      transactionRef: transRef,
      transactionID: transRef.id,
      productID,
      sellerID,
      clientID,
      productCost,
      deliveryCost,
      quantity,
      status: TransactionStatusTypes.Open,
      total: productCost * quantity + deliveryCost,
      events: [{ type: TransactionEventTypes.AwaitingPayment, createdAt: new Date() }],
      trackingCode: TrackingCodes.Dependent,
      createdAt: serverNowDateValue()
    });
  }
  batch.commit();
  return transRef.id;
};
